import styled from 'styled-components';
import * as Slider from '@radix-ui/react-slider';
import { vars } from '../../theme';

export const SliderRoot = styled(Slider.Root)`
    position: relative;
    display: flex;
    align-items: center;
    user-select: none;
    touch-action: none;
    width: 100%;
    height: 20px;
`;

export const SliderTrack = styled(Slider.Track)`
    background-color: ${vars.colors.stroke.secondary};
    position: relative;
    flex-grow: 1;
    height: 4px;
    border-radius: ${vars.radius.full};
`;

export const SliderRange = styled(Slider.Range)`
    position: absolute;
    background-color: ${vars.colors.base.accent};
    height: 100%;
    border-radius: ${vars.radius.full};
`;

export const SliderThumb = styled(Slider.Thumb)`
    display: block;
    width: 20px;
    height: 20px;
    background-color: ${vars.colors.surface.item};
    box-shadow: ${vars.shadow['20']};
    border-radius: ${vars.radius.full};
    cursor: pointer;
    transition: transform 0.3s ease-out, box-shadow 0.3s ease-out;

    &:focus {
        outline: none;
    }
`;

export const ValueLabel = styled.label`
    position: absolute;
    right: 0;
    top: -24px;
    font-family: ${vars.fonts.body};
    font-size: 14px;
    line-height: 1.29;
    color: ${vars.colors.text.tertiary};
`;
